import { mapActions, mapGetters } from "vuex";

export default function (moduleName, prefix) {
    var actionList = {};
    var getterList = {};

    actionList[prefix + "_execute"] = moduleName + "Module/execute";

    getterList[prefix + "_result"] = moduleName + "Module/result";
    getterList[prefix + "_working"] = moduleName + "Module/working";

    return {
        methods: {
            ...mapActions({ ...actionList }),
        },
        computed: {
            ...mapGetters(getterList),
        },
    };
}
